<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Registro Perfil
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="close(true)">Nuevo</v-btn>
            <ModalPerfilModuloOpcionComponent :open="obModal.open" :listGeneral="listGeneral" :parametros="parametros" :obModal="obModal" />
        </v-card-title>
        <v-container fluid grid-list-sm>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Perfil *" color="textbox" :items="listGeneral.listPerfil"
                        v-model='obSearch.idPerfil' outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Estado *" color="textbox" :items="listGeneral.listEstado"
                        item-text="nombre_estado" item-value="id_estado" v-model='obSearch.idEstado' outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-tooltip top color="primary">
                        <template v-slot:activator="{ on }">
                                <v-btn fab dark small color="primary" @click="onListar" v-on="on"
                                    :disabled="disabled">
                                    <v-icon dark>search</v-icon>
                                </v-btn>
                        </template>
                        <span>Buscar</span>
                    </v-tooltip>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="6"/>
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" v-model="obSearch.search" color="textbox" clearable dense prepend-inner-icon="search" />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-data-table :search="obSearch.search" :headers="listGeneral.cabecera" :items="listGeneral.detalle"
                        class="elevation-3">

                        <template v-slot:item.name="{ item }">
                            <v-btn class="ma-2" text icon color="primary" @click="editItem(item)">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: 'PerfilModuloOpcionView',
        components: {
            ModalPerfilModuloOpcionComponent: () => import('@/components/seguridad/ModalPerfilModuloOpcionComponent.vue')
        },
        data: () => ({
            obSearch:{
                search:'',
                idPerfil:null,
                idEstado:null
            },
            obModal: {
                open: false,
                titulo: '',
                perfil:null,
                idEstado:null,
                search:''
            },
            listGeneral: {},
            parametros: {},
            disabled:false
        }),
        created() {
            var error = 'E';
            this.disabled = true;
            axios.post(`${BASE_URI}administrador/perfil-modulo-opcion/cargaGeneral`)
                .then((r) => {
                        if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r, ['data', 'data'], [])) == 0) {  error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                            this.$set(this, 'listGeneral', r.data.data.listas);
                            this.$set(this, 'parametros', r.data.data.parametros);
                            this.obSearch.idEstado = _.toString(this.parametros.id_estado_default);
                            this.disabled = false;
                            this.onListar('L');
                })
                .catch((e) => {
                        this.disabled = false;
                        mensajesAlerta(e, error);
                })
        },
        methods: {
            onListar(ev){
                if(!_.isUndefined(ev)){
                    var error = 'E';
                    this.disabled = true;
                    this.listGeneral.detalle = [];
                    var o = {
                                opcion:'LISTAR_NRO_OPC_USU_PER',
                                idPerfil: this.obSearch.idPerfil,
                                idEstado: _.toNumber(this.obSearch.idEstado) == 0 ? null : this.obSearch.idEstado
                            };

                    axios.post(`${BASE_URI}administrador/perfil-modulo-opcion/listar`,o)
                        .then((r) => {
                                if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                if (_.size(_.get(r, ['data', 'data'], [])) == 0) {  error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                                    this.listGeneral.detalle = r.data.data;
                                    this.disabled = false;
                        })
                        .catch((e) => {
                                this.disabled = false;
                                mensajesAlerta(e, error);
                        })
                }
            },
            close(band){
                this.obModal = {
                    open: band,
                    titulo: 'Nuevo Perfil',
                    perfil:null,
                    search:'',
                    idEstado: _.toString(this.parametros.id_estado_default)
                }

                this.listGeneral.detalleModal = [];
                if(band)
                    this.listGeneral.detalleModal = this.listGeneral.listOpcion;
                
            },
            editItem(v){
                this.obModal = _.merge({},this.obModal,v,{titulo:'Editar Perfil'});
                this.onListarOpcion('L');
            },
            onListarOpcion(ev){
                if(!_.isUndefined(ev)){
                    var error = 'E';
                    this.disabled = true;
                    this.listGeneral.detalleModal = [];
                    var o = {
                                opcion:'LISTAR_OPC_PER',
                                idPerfil: this.obModal.idPerfil
                            };

                    axios.post(`${BASE_URI}administrador/perfil-modulo-opcion/listar`,o)
                        .then((r) => {
                                if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                if (_.size(_.get(r, ['data', 'data'], [])) == 0) {  error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                                    var l = _.cloneDeep(r.data.data);
                                    l = _.map(l,(v)=>{
                                            var c = v.check;
                                            v.check = _.toNumber(c) == 1 ? true : false;
                                            v.checkOld = _.toNumber(c) == 1 ? true : false;
                                        return v;
                                    });
                                    
                                    this.listGeneral.detalleModal = l;
                                    this.disabled = false;
                                    this.obModal.open = true;
                        })
                        .catch((e) => {
                                this.disabled = false;
                                mensajesAlerta(e, error);
                        })
                }
            },
            submit(listOpciones){
                var error = 'E';
                var keys = ['idPerfilModuloOpcion','idModulo','idOpcion','idEstado','check'];
                var o = {
                    obPerfil: _.pick(this.obModal,['idPerfil','perfil','idEstado']),
                    listOpciones:_.map(listOpciones,_.partialRight(_.pick,keys))
                };

                axios.post(`${BASE_URI}administrador/perfil-modulo-opcion/insertOrUpdate`,o)
                        .then((r)=>{
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) {  error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                                    mensajeAlertaTiempo(r.data.mensaje,'S');
                                    this.disabled = false;
                                    this.close(false);
                                    this.onListar('L');
                        })
                        .catch((e) => {
                            mensajesAlerta(e, error);
                            this.disabled = false;
                        });
            }
        },
        provide(){
            return{
                close:this.close,
                submit:this.submit
            }
        }
    }
</script>